import AddBusinessIcon from 'app-components/assets/icons/business/addBusiness.inline.svg';
import AddClientIcon from 'app-components/assets/icons/business/addClient.inline.svg';
import AddProductIcon from 'app-components/assets/icons/business/addProduct.inline.svg';
import CreateInvoiceIcon from 'app-components/assets/icons/business/createInvoiceTask.inline.svg';
import GetPaidFasterIcon from 'app-components/assets/icons/business/getPaidFaster.inline.svg';
import RecordSalesReceiptIcon from 'app-components/assets/icons/business/recordSalesReceipt.inline.svg';
import StepLockedInlineIcon from 'app-components/assets/icons/business/steplocked.inline.svg';
import TaskCompleteInlineIcon from 'app-components/assets/icons/business/taskcomplete.inline.svg';

export const taskIcons: Record<string, React.FunctionComponent<React.SVGAttributes<SVGElement>>> = {
  'add-business': AddBusinessIcon,
  'add-client': AddClientIcon,
  'add-products': AddProductIcon,
  'set-up-online-payment': GetPaidFasterIcon,
  'create-invoice': CreateInvoiceIcon,
  'record-sales-receipt': RecordSalesReceiptIcon,
};

export { StepLockedInlineIcon, TaskCompleteInlineIcon };

import addBusinessAnim from 'assets/animations/business/addBusiness.json';
import addClientAnim from 'assets/animations/business/addClient.json';
import addProductAnim from 'assets/animations/business/addProduct.json';
import createInvoiceAnim from 'assets/animations/business/createInvoice.json';
import getPaidFasterAnim from 'assets/animations/business/getPaidFaster.json';
import recordSalesReceiptAnim from 'assets/animations/business/recordSalesReceipt.json';

export const taskAnimations: Record<string, Record<string, unknown> | undefined> = {
  'add-business': addBusinessAnim as Record<string, unknown>,
  'add-client': addClientAnim as Record<string, unknown>,
  'add-products': addProductAnim as Record<string, unknown>,
  'set-up-online-payment': getPaidFasterAnim as Record<string, unknown>,
  'create-invoice': createInvoiceAnim as Record<string, unknown>,
  'record-sales-receipt': recordSalesReceiptAnim as Record<string, unknown>,
};

import stepLockedAnim from 'assets/animations/business/steplocked.json';
import taskCompleteAnim from 'assets/animations/business/taskcomplete.json';

export const stepLockedAnimation = stepLockedAnim as Record<string, unknown>;
export const taskCompleteAnimation = taskCompleteAnim as Record<string, unknown>;
